import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { NestedProductCategoryDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, { id: string; payload: Partial<NestedProductCategoryDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.NESTED_PRODUCT_CATEGORY}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'nested-product-category', id: 'GET-ID' },
            { type: 'nested-product-categories', id: 'GET' },
        ],
    });
